import React, { useState } from 'react';
import { Link, graphql } from 'gatsby';
import { useFlexSearch } from 'react-use-flexsearch';
import AllPostsLayout from '../components/all-posts-layout';
import * as blogStyles from '../blog.module.css';
import Seo from '../components/seo';
import SearchBar from '../components/search';
import { unFlattenResults } from '../../utils/search';

const BlogPosts = ({ data }) => {
   const [searchQuery, setSearchQuery] = useState('');
   const siteTitle = data.site.siteMetadata?.title || `Title`;

   const nodes = data.allMarkdownRemark.nodes;
   const { index, store } = data.localSearchPages;
   const results = useFlexSearch(searchQuery, index, store);
   const posts = searchQuery ? unFlattenResults(results) : nodes;

   return (
      <AllPostsLayout
         headerTitle={siteTitle}
         avatar={data.site.siteMetadata.author.avatar}
      >
         <Seo title="Posts" />
         <SearchBar searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
         <section className={blogStyles.articles}>
            {posts.length ? (
               posts.map((post) => {
                  const title = post.frontmatter.title || post.fields.slug;
                  const date = post.frontmatter.date;

                  return (
                     <article
                        key={post.fields.slug}
                        className={blogStyles.article}
                     >
                        <Link
                           to={post.fields.slug}
                           itemProp="url"
                           replace={true}
                        >
                           <img
                              src={post.frontmatter.cover}
                              alt="blog cover"
                              className={blogStyles.articleImage}
                           />
                        </Link>
                        <div className={blogStyles.articleText}>
                           <h2 className={blogStyles.articleTitle}>
                              <Link
                                 to={post.fields.slug}
                                 itemProp="url"
                                 replace={true}
                              >
                                 {title}
                              </Link>
                           </h2>
                           <small className={blogStyles.date}>{date}</small>
                           <div className={blogStyles.tags}>
                              {post.frontmatter.tags.map((tag) => (
                                 <Link
                                    key={tag}
                                    to={`/tags/${tag
                                       .replace('.', '')
                                       .toLowerCase()}`}
                                    itemProp="url"
                                    replace={true}
                                    className={blogStyles.tag}
                                 >
                                    {tag}
                                 </Link>
                              ))}
                           </div>
                           <p className={blogStyles.excerpt}>
                              {post.frontmatter.excerpt}
                           </p>
                        </div>
                     </article>
                  );
               })
            ) : (
               <p>
                  Sorry 😟, No blog posts were found matching your search 🔍.
               </p>
            )}
         </section>
      </AllPostsLayout>
   );
};

export default BlogPosts;

export const pageQuery = graphql`
   query {
      site {
         siteMetadata {
            title
            author {
               avatar
            }
         }
      }
      localSearchPages {
         index
         store
      }
      allMarkdownRemark(
         sort: { fields: [frontmatter___date], order: DESC }
         limit: 10
         filter: { frontmatter: { published: { eq: true } } }
      ) {
         nodes {
            fields {
               slug
            }
            frontmatter {
               date(formatString: "MMMM DD, YYYY")
               title
               tags
               cover
               excerpt
            }
         }
      }
   }
`;
